import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import * as styles from './TabMessage.css';

const cx = classNames.bind(styles);

const renderText = (text) => {
    if (typeof text === 'string') {
        return text;
    }
    // text is an array of { text, bold? } parts
    return text.map((part, index) =>
        part.bold ? (
            <span key={index} className={cx('boldText')}>
                {part.text}
            </span>
        ) : (
            <span key={index}>{part.text}</span>
        )
    );
};

const TabMessage = ({ message }) => {
    if (!message) {
        return null;
    }

    const { type, text } = message;
    const isInfo = type === 'info';
    const isCongrats = type === 'congrats';

    return (
        <div className={cx('tabMessage', { info: isInfo, congrats: isCongrats })} role="alert">
            <p className={cx('messageText')}>{renderText(text)}</p>
        </div>
    );
};

TabMessage.propTypes = {
    message: PropTypes.shape({
        type: PropTypes.oneOf(['info', 'congrats']).isRequired,
        text: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(
                PropTypes.shape({
                    text: PropTypes.string.isRequired,
                    bold: PropTypes.bool,
                })
            ),
        ]).isRequired,
    }),
};

TabMessage.defaultProps = {
    message: null,
};

export default TabMessage;
